import { Check, Minus } from "lucide-react";
import { Eyebrow, Reveal, SectionShell } from "./Shared";

const STANDARD = ["Contract negotiation", "Sponsorship outreach", "Opportunity management", "Stops at the signature."];
const SMG = [
  "Identity & positioning",
  "Content & audience growth",
  "Sponsorship value engineering",
  "A long-term commercial platform that outlasts the game.",
];

export default function Difference() {
  return (
    <SectionShell id="difference" className="bg-surface/40">
      <Reveal>
        <Eyebrow className="mb-5">— 02 / The SMG Difference</Eyebrow>
        <h2 className="max-w-3xl font-display text-4xl uppercase leading-[1.05] sm:text-5xl lg:text-6xl">
          Representation <span className="text-outline">meets</span>{" "}
          <span className="text-volt">brand development.</span>
        </h2>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">
          Most agencies negotiate deals. SMG also builds the athlete's identity,
          content, audience, sponsorship value and long-term commercial platform.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-2">
        <Reveal delay={0.1} className="h-full">
          <div
            className="h-full rounded-3xl border border-white/10 bg-ink p-8 sm:p-10"
            data-testid="difference-standard-card"
          >
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500">
              The Standard Agency
            </p>
            <h3 className="mt-3 font-display text-3xl uppercase text-slate-400">
              Negotiates the deal.
            </h3>
            <ul className="mt-8 space-y-4">
              {STANDARD.map((item) => (
                <li key={item} className="flex items-start gap-3 text-slate-400">
                  <Minus className="mt-1 h-4 w-4 shrink-0 text-slate-600" />
                  <span className="text-base">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.2} className="h-full">
          <div
            className="relative h-full overflow-hidden rounded-3xl border border-volt/40 bg-gradient-to-br from-elev to-ink p-8 shadow-[0_0_60px_rgba(132,204,22,0.08)] sm:p-10"
            data-testid="difference-smg-card"
          >
            <div
              className="absolute -right-20 -top-20 h-56 w-56 rounded-full bg-volt/20 blur-[80px]"
              aria-hidden="true"
            />
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-volt">
              The SMG Standard
            </p>
            <h3 className="mt-3 font-display text-3xl uppercase text-white">
              Builds the athlete.
            </h3>
            <ul className="mt-8 space-y-4">
              {SMG.map((item) => (
                <li key={item} className="flex items-start gap-3 text-slate-200">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-volt/15">
                    <Check className="h-3.5 w-3.5 text-volt" />
                  </span>
                  <span className="text-base">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </SectionShell>
  );
}
